exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .card--slim {\n  border-radius: 10px;\n  height: 40px;\n  overflow: visible;\n  cursor: pointer;\n  margin: 0px; }\n  :host .card--slim .row {\n    margin: -8px -16px; }\n\n:host .action-icon {\n  color: #9c9b99; }\n  :host .action-icon:hover {\n    color: #76797E; }\n\n:host .col--icon {\n  text-align: center;\n  width: 104px; }\n\n:host .col--delete {\n  text-align: center;\n  width: 104px; }\n\n:host .col--created {\n  width: 210px; }\n\n:host .col--modified {\n  width: 210px; }\n\n:host .col--status {\n  width: 130px; }\n\n:host .col--recipient {\n  width: 260px; }\n\n:host .col--name {\n  width: calc(100% - 1018px); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/questionnaires-item/questionnaires-item.component.scss
// module id = ../../../../../src/app/components/questionnaires-item/questionnaires-item.component.scss
// module chunks = main